import React from 'react';
import FileUploadField from '../../../components/Fields/FileUploadField';
import { FieldProps } from '../../../components/Fields/Types';
import WorkflowTaskAddDocumentModel from '../../../models/WorkflowTaskAddDocumentModel';

interface IProps {
    formData: WorkflowTaskAddDocumentModel
    getFieldProps: (fieldName: string) => FieldProps

}
const TaskAddDocumentView: React.FC<IProps> = ({ formData, getFieldProps }) => {

    const allowMultiple = formData.attachmentType.maxAttachments !== 1

    return (
        <FileUploadField {...getFieldProps('workflowTaskAddDocumentModel.document')} multiple={allowMultiple} />
    )
}
export default TaskAddDocumentView;